module.exports = __webpack_public_path__ + "static/media/band-alt.1a619717.svg";